import { ReactElement } from 'react';

import { useTimeBasedAuthenticationConfigurationCqrsFind } from '@dreryk/egabinet-security-frontend';

import { shouldDisplayMfaRequiredModal } from './MfaRequiredModal.utils';

type MfaRequiredModalLoaderProps = {
   children: ReactElement;
};

export const MfaRequiredModalLoader = (props: MfaRequiredModalLoaderProps): ReactElement | null => {
   const displayMfaRequiredModal = shouldDisplayMfaRequiredModal();
   const {
      data: mfaConfiguration,
      loading: mfaConfigurationLoading,
      error: mfaConfigurationError,
   } = useTimeBasedAuthenticationConfigurationCqrsFind({ enabled: displayMfaRequiredModal });

   if (mfaConfigurationLoading || mfaConfigurationError || !displayMfaRequiredModal || Boolean(mfaConfiguration)) {
      return null;
   }

   return props.children;
};
